<template>
  <div>
    <a-table :scroll="{ x: 1200 }" :expand-icon-column-index="1" :pagination="false" :columns="columns" size="middle" :data-source="tableData" row-key="key" :loading="loading">
      <span slot="customerTitle" slot-scope="text, record">
        <span class="story-edit">
          <a-tooltip v-if="record.item_type === 'requirement'" title="需求" style="margin-right: 4px">
            <svg t="1670220391514" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12755" width="16" height="16">
              <path
                d="M849.170732 0c97.404878 0 174.829268 77.42439 174.829268 174.829268v674.341464c0 97.404878-77.42439 174.829268-174.829268 174.829268H174.829268c-97.404878 0-174.829268-77.42439-174.829268-174.829268V174.829268c0-97.404878 77.42439-174.829268 174.829268-174.829268h674.341464z m-247.258537 774.243902h-172.331707l67.434146 32.468293c9.990244 4.995122 22.478049 4.995122 34.965854 0l69.931707-32.468293z m7.492683-69.931707h-189.814634c-9.990244 0-19.980488 7.492683-19.980488 17.482927 0 9.990244 7.492683 17.482927 19.980488 17.482927h189.814634c9.990244 0 19.980488-7.492683 19.980488-17.482927 0-9.990244-7.492683-17.482927-19.980488-17.482927zM514.497561 237.268293c-62.439024 0-114.887805 19.980488-159.843902 62.439024-44.956098 42.458537-64.936585 92.409756-64.936586 152.35122v29.970731c0 7.492683 2.497561 14.985366 2.497561 19.980488v4.995122c2.497561 7.492683 4.995122 14.985366 7.492683 19.980488 2.497561 7.492683 4.995122 14.985366 9.990244 22.478049 7.492683 14.985366 17.482927 27.473171 27.473171 42.458536l17.482927 14.985366 2.497561 2.497561 4.995121 4.995122 2.497561 2.497561 9.990244 7.492683 2.497561 2.497561h2.497561c4.995122 4.995122 9.990244 9.990244 14.985366 17.482927 2.497561 7.492683 7.492683 12.487805 9.990244 14.985366 2.497561 2.497561 9.990244 4.995122 17.482927 4.995122H599.414634c7.492683 0 14.985366-2.497561 17.482927-4.995122 2.497561-2.497561 4.995122-7.492683 9.990244-14.985366 2.497561-7.492683 7.492683-12.487805 14.985366-17.482927h2.497561l2.497561-2.497561 9.990244-7.492683c0-2.497561 2.497561-2.497561 2.497561-2.497561 2.497561-2.497561 2.497561-4.995122 7.492682-7.492683h2.497561c4.995122-4.995122 12.487805-9.990244 17.482927-14.985366 4.995122-7.492683 9.990244-12.487805 14.985366-19.980488 4.995122-7.492683 9.990244-14.985366 12.487805-22.478048 2.497561-4.995122 4.995122-12.487805 9.990244-22.478049 2.497561-4.995122 4.995122-12.487805 7.492683-19.980488v-2.497561l2.497561-19.980488v-4.995122-24.975609c0-59.941463-22.478049-109.892683-67.434147-152.35122-37.463415-44.956098-89.912195-64.936585-152.351219-64.936585z m19.980488 69.931707c34.965854 0 64.936585 12.487805 92.409756 34.965854 27.473171 22.478049 39.960976 54.946341 39.960975 92.409756 0 9.990244-7.492683 17.482927-19.980487 17.482927s-19.980488-9.990244-19.980488-17.482927c0-24.97561-9.990244-47.453659-29.970732-64.936586-19.980488-17.482927-42.458537-27.473171-64.936585-27.47317-9.990244 0-19.980488-7.492683-19.980488-17.482927 2.497561-7.492683 12.487805-17.482927 22.478049-17.482927z"
                fill="#8D90F2"
                p-id="12756"
              />
            </svg>
          </a-tooltip>
          <a-tooltip v-if="record.item_type === 'task'" title="任务" style="margin-right: 4px">
            <svg t="1662379348404" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1217" width="16" height="16">
              <path d="M728.4736 936.3456H393.5744c-130.6112 0-236.4416-105.8816-236.4416-236.4416V266.6496c0-87.6032 71.0144-158.6176 158.6176-158.6176h334.8992c130.6112 0 236.4416 105.8816 236.4416 236.4416v433.2544c0 87.6032-71.0144 158.6176-158.6176 158.6176z" fill="#6FCBF6" p-id="1218" />
              <path d="M640.8192 246.4256H298.8544c-78.2848 0-141.7216 63.4368-141.7216 141.7216v301.9264c0 135.9872 110.1824 246.2208 246.1696 246.2208h325.1712c87.6032 0 158.5664-71.0144 158.6176-158.5664V492.6976c0-136.0384-110.2336-246.272-246.272-246.272z" fill="#68BEF3" p-id="1219" />
              <path d="M640.8192 384.8192H298.8544c-78.2848 0-141.7216 63.4368-141.7216 141.7216v163.5328c0 135.9872 110.1824 246.2208 246.1696 246.2208h325.1712c87.6032 0 158.5664-71.0144 158.6176-158.5664v-146.688c0-135.9872-110.2336-246.2208-246.272-246.2208z" fill="#5CAAF0" p-id="1220" />
              <path d="M676.5056 361.9328h-308.736c-22.0672 0-39.9872-16.4352-39.9872-36.7616 0-20.2752 17.92-36.7616 39.9872-36.7616h308.736c22.0672 0 39.9872 16.4352 39.9872 36.7616 0 20.3264-17.92 36.7616-39.9872 36.7616zM577.3824 555.4688H367.7184c-22.0672 0-39.9872-16.4352-39.9872-36.7616s17.92-36.7616 39.9872-36.7616h209.664c22.0672 0 39.9872 16.4352 39.9872 36.7616s-17.8688 36.7616-39.9872 36.7616z" fill="#FFFFFF" p-id="1223" />
            </svg>
          </a-tooltip>
          <a-tooltip placement="top" :title="record.title">
            <a v-if="record.item_type === 'requirement'" class="story-edit_title" :href="link(record.item_type, record.id)" target="_blank">{{ record.title }}</a>
            <a v-if="record.item_type === 'task'" class="story-edit_title" :href="link(record.item_type, record.id)" target="_blank">{{ record.name }}</a>
          </a-tooltip>
        </span>
      </span>
      <span slot="customTitleHeader">标题</span>
      <span slot="status" slot-scope="text, record">
        <span class="edit-status">
          <a-badge v-if="record.item_type === 'requirement'" :status="storyStatus[record.status].status" :text="storyStatus[record.status].label" />
          <a-badge v-if="record.item_type === 'task' && taskStatus[record.status]" :status="taskStatus[record.status].status" :color="taskStatus[record.status].color" :text="taskStatus[record.status].label" />
        </span>
      </span>
      <span slot="priority" slot-scope="text, record">
        <span v-if="record.item_type === 'requirement'">{{ record.priority || '--' }}</span>
        <a-tag v-if="record.item_type === 'task' && taskPrioritys[record.priority]" :color="taskPrioritys[record.priority].color">{{ taskPrioritys[record.priority].label }}</a-tag>
      </span>
      <span slot="type" slot-scope="text, record">
        <span>
          <a-badge v-if="record.item_type === 'requirement' && storyTypes[record.requirement_type]" :color="storyTypes[record.requirement_type].color" :text="storyTypes[record.requirement_type].label" />
          <span v-else>--</span>
        </span>
      </span>
      <span slot="isReview" slot-scope="text, record">
        <span>
          <a-tag v-if="record.item_type === 'requirement' && storyReviews[record.is_review]" :color="storyReviews[record.is_review].color">{{ storyReviews[record.is_review].label }}</a-tag>
        </span>
      </span>
      <span slot="technicalReview" slot-scope="text, record">
        <span v-if="record.item_type === 'requirement'">
          <a-popover v-if="record.technical_review" title="评审内容">
            <template slot="content">
              <p v-text="record.technical_review" />
            </template>
            <a-tag color="green">已评审</a-tag>
          </a-popover>
          <a-tag v-else color="blue">未评审</a-tag>
        </span>
      </span>
      <span slot="version" slot-scope="text, record"> {{ record.version.name || '--' }} </span>
      <span slot="progress" slot-scope="text, record">
        <a-progress v-if="record.item_type === 'requirement'" :percent="record.progress.progress" size="small" />
      </span>
      <span slot="taskTotal" slot-scope="text, record">
        <span v-if="record.item_type === 'requirement'">
          {{ record.progress.total || 0 }}<span class="task-points">({{ (record.progress.total || 0) * 2 }}人时)</span>
        </span>
        <span v-if="record.item_type === 'task'">
          {{ record.point }}<span class="task-points">({{ record.point * 2 }}人时)</span>
        </span>
      </span>
      <span slot="startTime" slot-scope="text, record">
        <span v-if="record.item_type === 'requirement'" class="story-date">{{ record.start_time || '--' }}</span>
        <span v-if="record.item_type === 'task'" class="story-date">{{ record.pre_start_time || '--' }}</span>
      </span>
      <span slot="endTime" slot-scope="text, record">
        <span v-if="record.item_type === 'requirement'" class="story-date">{{ record.end_time || '--' }}</span>
        <span v-if="record.item_type === 'task'" class="story-date">{{ record.pre_end_time || '--' }}</span>
      </span>
      <span slot="handlers" slot-scope="text, record">
        <span v-if="handlers(record)">
          <a-popover placement="topLeft">
            <template slot="content">
              <span v-for="handler in handlers(record)" :key="handler.id">
                <a-avatar :size="20" :src="handler.avatar_url" /> <span class="nickname">{{ handler.nickname }} </span>
              </span>
            </template>
            <span slot="title">负责人</span>
            <span v-for="handler in handlers(record)" :key="handler.id"> {{ handler.nickname }}; </span>
          </a-popover>
        </span>
        <span v-else> -- </span>
      </span>
      <span slot="pm" slot-scope="text, record">
        <span v-if="pm(record)">
          <a-popover placement="topLeft">
            <template slot="content">
              <span v-for="productManager in pm(record)" :key="productManager.id">
                <a-avatar :size="20" :src="productManager.avatar_url" /> <span class="nickname">{{ productManager.nickname }} </span>
              </span>
            </template>
            <span slot="title">产品</span>
            <span v-for="productManager in pm(record)" :key="productManager.id"> {{ productManager.nickname }}; </span>
          </a-popover>
        </span>
        <span v-else> -- </span>
      </span>
      <span slot="om" slot-scope="text, record">
        <span v-if="om(record)">
          <a-popover placement="topLeft">
            <template slot="content">
              <span v-for="operator in om(record)" :key="operator.id">
                <a-avatar :size="20" :src="operator.avatar_url" /> <span class="nickname">{{ operator.nickname }} </span>
              </span>
            </template>
            <span slot="title">运营</span>
            <span v-for="operator in om(record)" :key="operator.id"> {{ operator.nickname }}; </span>
          </a-popover>
        </span>
        <span v-else> -- </span>
      </span>
      <span slot="creator" slot-scope="text, record"> {{ record.creator.nickname }}</span>
      <span slot="createTime" slot-scope="text, record">
        <span class="story-date">{{ record.created_time || '--' }}</span>
      </span>
      <span slot="updateTime" slot-scope="text, record">
        <span class="story-date">{{ record.updated_time || '--' }}</span>
      </span>
    </a-table>
  </div>
</template>

<script>
import { storyStatus, storyTypes, storyReviews, taskStatus, taskPrioritys } from '@/utils/dictionary';
import { storyList } from '@/api/project/story';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 90,
    customRender: (_text, _row) => {
      return (_row.item_type === 'task' ? 'TS-' : 'PR-') + _text;
    }
  },
  {
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
    width: 400,
    slots: { title: 'customTitleHeader' },
    scopedSlots: { customRender: 'customerTitle' }
  },
  {
    title: '负责人',
    dataIndex: 'handlers',
    key: 'handlers',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'handlers' }
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 140,
    scopedSlots: { customRender: 'status' }
  },
  // {
  //   title: '迭代',
  //   dataIndex: 'version_name',
  //   key: 'version_name',
  //   width: 120,
  //   ellipsis: true
  // },
  {
    title: '进度',
    width: 110,
    align: 'center',
    scopedSlots: { customRender: 'progress' }
  },
  // {
  //   title: '任务Points',
  //   width: 110,
  //   scopedSlots: { customRender: 'taskTotal' }
  // },
  {
    title: '开始时间',
    dataIndex: 'start_time',
    key: 'start_time',
    align: 'center',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'startTime' }
  },
  {
    title: '结束时间',
    dataIndex: 'end_time',
    key: 'end_time',
    align: 'center',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'endTime' }
  },
  {
    title: '需求类型',
    dataIndex: 'requirement_type',
    key: 'requirement_type',
    width: 110,
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '优先级',
    dataIndex: 'priority',
    key: 'priority',
    width: 80,
    sorter: true,
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '已评审',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'isReview' }
  },
  {
    title: '技术评审',
    width: 90,
    align: 'center',
    scopedSlots: { customRender: 'technicalReview' }
  },
  // {
  //   title: '任务完成时间',
  //   dataIndex: 'completed_time',
  //   key: 'completed_time',
  //   align: 'center',
  //   width: 170
  // },
  {
    title: '产品',
    dataIndex: 'pm',
    key: 'pm',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'pm' }
  },
  {
    title: '运营',
    dataIndex: 'om',
    key: 'om',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'om' }
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    key: 'creator',
    align: 'center',
    width: 80,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time',
    align: 'center',
    width: 170,
    scopedSlots: { customRender: 'createTime' }
  },
  {
    title: '更新时间',
    dataIndex: 'updated_time',
    key: 'updated_time',
    align: 'center',
    width: 170,
    scopedSlots: { customRender: 'updateTime' }
  }
];
export default {
  name: 'SubStoryList',
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    filterForm: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      tableData: [],
      loading: false,
      columns,
      storyStatus,
      storyTypes,
      storyReviews,
      taskStatus,
      taskPrioritys
    };
  },
  computed: {
    handlers() {
      return record => {
        return record.handlers || null;
      };
    },
    pm() {
      return record => {
        return record.pm || null;
      };
    },
    om() {
      return record => {
        return record.operators || null;
      };
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        this.tableData = val;
      }
    }
  },
  methods: {
    link(type, storyId) {
      if (type === 'requirement') {
        return this.$router.resolve({
          name: 'page:project:story:detail',
          query: { storyId: storyId }
        }).href;
      } else if (type === 'task') {
        // 目前没有任务详情
        // return this.$router.resolve({name: 'page:project:task:detail', query: {storyId: storyId}}).href;
      }
    },
    handleChange() {
      this.getStoryList();
    },

    getStoryList() {
      this.loading = true;
      this.tableData = [];
      storyList({
        ...this.filterForm,
        ...this.sorter,
        show_task: true
      })
        .then(res => {
          this.tableData = res.data.items;
          this.allDataKeys = res.data.requirement_ids;
          this.defaultDataKeys = res.data.default_requirement_ids;
          if (this.expandedRowKeys.length === 0) {
            this.expandedRowKeys = this.expanded === true ? [...this.defaultDataKeys] : [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.story-edit_title {
  color: rgba(0, 0, 0, 0.65);
  line-height: 16px;
  max-width: 320px;
  display: inline-block;
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) 需与 overflow:hidden;一起使用。*/
}

.story-edit_icon {
  opacity: 0;
  // float: left;
  padding-top: 4px;
  padding-left: 2px;
}

.story-edit:hover {
  .story-edit_title {
    cursor: pointer;
    color: #1890ff;
  }

  .story-edit_icon {
    opacity: 1;
  }
}
</style>
